import APP from '@monorepo/old-web/js/config';
import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { Main } from '@monorepo/shared/componentsV2/Main';
import { useCurrentProject } from '@monorepo/shared/hooks/useCurrentProject';
import {
  fillHeightAndScrollable,
  page,
  verticalLayout,
} from '@monorepo/shared/styles/layout';
import React from 'react';
import styled from 'styled-components';
import { ComplianceCalendar } from './ComplianceCalendar/ComplianceCalendar';
import { ComplianceCalendarPageModals } from './ComplianceCalendarPageModals';

const StyledMain = styled(Main)`
  ${verticalLayout}
  ${page}
`;

/*
 * Flex column so week and list views can bound themselves to the space under
 * the page header and scroll their own content; scrollable so month view,
 * which grows with its content, scrolls the page instead.
 */
const CalendarScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${fillHeightAndScrollable}
  padding: 0 2rem 2rem;
`;

export function ComplianceCalendarPage() {
  const { project } = useCurrentProject();

  APP.projectId = project?.id; // Legacy code grabs projectId from the App object

  return (
    <StyledMain>
      <ComplianceCalendarPageModals />
      <Header
        title="Compliance Calendar"
        subtitle={project?.name}
        variant="noDropShadow"
      />
      <ErrorBoundary>
        <CalendarScrollContainer>
          {project ? <ComplianceCalendar /> : <Loading />}
        </CalendarScrollContainer>
      </ErrorBoundary>
    </StyledMain>
  );
}
